import React from 'react';
import { useHarmonyTheming } from './index';
var HarmonyThemeComponent = function (props) {
    useHarmonyTheming(props.scrollContentRef);
    return null;
};
export var HarmonyThemingComponent = React.memo(HarmonyThemeComponent);
//# sourceMappingURL=HarmonyThemeComponent.js.map